var paragraph_default = {
  "fontElementMap": "_2KnjV",
  "elementSpacing": "jE03w",
  "text": "eFmwP jE03w",
  "child": "_5wXHi"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
